module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-500-Classes-Inactive-05500b4cb0aa64e99310260e8e08558c.png";